// This file is automatically generated. Do not edit manually.

import { ProjectActivityMaterialState } from "src/api/generated/erp/db/types/enums/projectActivityMaterialState";
import { AcquisitionMethod } from "src/api/generated/erp/db/types/enums/acquisitionMethod";
import { LineFilterMode } from "src/api/generated/erp/project/projectActivityMaterial/lineFilterMode";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ProjectActivity } from "src/api/generated/erp/db/types/tables/projectActivity";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { SubProject } from "src/api/generated/erp/db/types/tables/subProject";
import { ProjectActivityMaterialView } from "src/api/generated/erp/db/types/tables/projectActivityMaterialView";
import { ProjectActivityMaterialViewActivityState } from "src/api/generated/erp/db/types/enums/projectActivityMaterialViewActivityState";
import { IsoDateTimeString } from "src/types/dateTime";
import { IsoDateString } from "src/types/dateTime";
import { PurchaseOrderLineState } from "src/api/generated/erp/db/types/enums/purchaseOrderLineState";
import { ProjectActivityMaterialViewShopOrderState } from "src/api/generated/erp/db/types/enums/projectActivityMaterialViewShopOrderState";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProjectActivityMaterialsDataGridApi {
	export async function getDataGridDataForActivity(args: {
		projectActivityId: number;
		cancelledLines: boolean;
		searchQuery?: string;
		stateFilter?: Array<ProjectActivityMaterialState>;
		acquisitionMethodFilter?: Array<AcquisitionMethod>;
		lineFilterMode?: LineFilterMode;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ProjectActivityMaterialsDataGridApi_DataGridData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterialsDataGrid/getDataGridDataForActivity",
			method: "POST",
			data: {
				projectActivityId: args.projectActivityId,
				cancelledLines: args.cancelledLines,
				searchQuery: args.searchQuery,
				stateFilter: args.stateFilter,
				acquisitionMethodFilter: args.acquisitionMethodFilter,
				lineFilterMode: args.lineFilterMode,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ProjectActivityMaterialsDataGridApi_DataGridData;
	}

	export async function getDataGridDataForProject(args: {
		projectId: number;
		subProjectId?: number | null | undefined;
		cancelledLines: boolean;
		searchQuery?: string;
		stateFilter?: Array<ProjectActivityMaterialState>;
		acquisitionMethodFilter?: Array<AcquisitionMethod>;
		lineFilterMode?: LineFilterMode;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ProjectActivityMaterialsDataGridApi_DataGridData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterialsDataGrid/getDataGridDataForProject",
			method: "POST",
			data: {
				projectId: args.projectId,
				subProjectId: args.subProjectId,
				cancelledLines: args.cancelledLines,
				searchQuery: args.searchQuery,
				stateFilter: args.stateFilter,
				acquisitionMethodFilter: args.acquisitionMethodFilter,
				lineFilterMode: args.lineFilterMode,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ProjectActivityMaterialsDataGridApi_DataGridData;
	}
}

export interface ProjectActivityMaterialsDataGridApi_DataGridData {
	activity: ProjectActivity | null | undefined;
	data: ServerSideDataModelResult<ProjectActivityMaterialsDataGridApi_ProjectActivityMaterialDto>;
	subProjectOptions: Array<SubProject>;
}

export interface ProjectActivityMaterialsDataGridApi_ProjectActivityMaterialDto {
	childLines: Array<ProjectActivityMaterialView>;
	acquisitionMethod: AcquisitionMethod;
	activityId: number;
	activityName: string;
	activityState: ProjectActivityMaterialViewActivityState | null | undefined;
	activityTypeId: number;
	cancelledAt: IsoDateTimeString | null | undefined;
	cancelledByUserId: number | null | undefined;
	cancelledByUserName: string | null | undefined;
	capacityQuantity: number;
	configurationOrPartDescription: string;
	createdAt: IsoDateTimeString;
	createdByUserId: number;
	createdByUserName: string;
	customerName: string | null | undefined;
	customerOrderId: number | null | undefined;
	customerOrderReference: string | null | undefined;
	deliveredQuantityInBaseUnit: number;
	demandDate: IsoDateString;
	lastPickingDate: IsoDateString | null | undefined;
	lastUpdated: IsoDateTimeString;
	lineNumber: number;
	mark: string;
	parentMaterialId: number | null | undefined;
	partConfigurationId: number | null | undefined;
	partDefaultProductionLineId: number | null | undefined;
	partDescription_1: string;
	partDescription_2: string;
	partId: number;
	partIsConfigurable: boolean;
	partNo: string;
	partUnit: string;
	pickedQuantityInBaseUnit: number;
	projectActivityMaterialId: number;
	projectDescription: string;
	projectId: number;
	purchaseOrderId: number | null | undefined;
	purchaseOrderLineId: number | null | undefined;
	purchaseOrderLinePlannedArrivalDate: IsoDateString | null | undefined;
	purchaseOrderLineState: PurchaseOrderLineState | null | undefined;
	quantityInBaseUnit: number;
	releasedAt: IsoDateTimeString | null | undefined;
	releasedByUserId: number | null | undefined;
	releasedByUserName: string | null | undefined;
	reservedQuantityInBaseUnit: number;
	shopOrderBatchCode: string | null | undefined;
	shopOrderId: number | null | undefined;
	shopOrderState: ProjectActivityMaterialViewShopOrderState | null | undefined;
	siteId: number;
	sitePickingDurationDays: number;
	state: ProjectActivityMaterialState;
	subProjectDescription: string;
	subProjectId: number;
	supplierId: number | null | undefined;
	supplierName: string | null | undefined;
	unitCost: number;
}
